import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import Legal from '@/components/Legal'
import Profile from '@/components/Profile'
import Strava from '@/components/Strava'
import Trainingym from '@/components/Trainingym'
import Spinning from '@/components/Spinning'
import Treadmill from '@/components/Treadmill'
import Elliptical from '@/components/Elliptical'
import GlobalView from '@/components/GlobalView'
import firebase from 'firebase/compat/app';


Vue.use(Router)

let router = new Router({
  //mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/new',
      name: 'New',
      component: Login,
      props: { isNew: true }
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    // {
    //   path: '/sign-up',
    //   name: 'SignUp',
    //   component: SignUp
    // },
    {
      path: '/dashboard',
     // name: 'Dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'parent',
          redirect: { name: 'Global View' }
        },
        {
          name: 'Global View',
          path: '/globalview',
          redirect: '/globalview',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/globalview',
              component: GlobalView
            }
          ]
        },
        {
          name: 'Profile',
          path: '/profile',
          redirect: '/profile',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/profile',
              component: Profile
            }
          ],
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'Strava',
          path: '/strava',
          redirect: '/strava',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/strava',
              component: Strava
            }
          ]
        },
        {
          name: 'Trainingym',
          path: '/trainingym',
          redirect: '/trainingym',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/trainingym',
              component: Trainingym
            }
          ]
        },
        {
          name: 'Indoor cycling',
          path: '/indoor_cycling',
          redirect: '/indoor_cycling',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/indoor_cycling',
              component: Spinning
            }
          ]
        },
        {
          name: 'Tredmill',
          path: '/treadmill',
          redirect: '/treadmill',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/treadmill',
              component: Treadmill
            }
          ]
        },
        {
          name: 'Elliptical',
          path: '/elliptical',
          redirect: '/elliptical',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/elliptical',
              component: Elliptical
            }
          ]
        },
      ],
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/profile',
    //   name: 'Profile',
    //   component: Profile,
    //   meta: {
    //     requiresAuth: true
    //   }
    // }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let verifiedEmail = (currentUser) ? currentUser.emailVerified : false;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && verifiedEmail === false) next('login')
  // else if (!requiresAuth && currentUser) next('Dashboard')
  else next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js